<template>
  <v-container class="" fluid>
    <v-row justify="center" align="center" style="min-height: 100vh;">
      <v-col cols="12" md="6">
        <div v-if="loading" class="loading-container">
          <v-row justify="center" align="center">
            <v-col cols="auto" class="text-center">
              <v-progress-circular indeterminate color="primary" size="64" />
              <p class="mt-4 text-subtitle-1 font-italic">Uploading file...</p>
              <v-progress-linear
                :value="uploadProgress"
                height="6"
                color="primary"
                class="mt-4"
              />
            </v-col>
          </v-row>
        </div>

        <div v-else>
          <v-card class="pa-4 elevation-2">
            <h4 class="mb-3">Send a File</h4>
            <v-form @submit.prevent="handleUpload">
              <v-file-input
                label="Choose File"
                @change="onFileChange"
                outlined
                dense
                class="mb-3"
                :rules="[validateFileType]"
              />
              <div v-if="selectedFile" class="mb-3">
                <p><strong>Name:</strong> {{ selectedFile.name }}</p>
                <p><strong>Size:</strong> {{ formatSize(selectedFile.size) }}</p>
                <p><strong>Type:</strong> {{ selectedFile.type || 'Unknown' }}</p>
              </div>
              <v-btn type="submit" color="primary" block>Upload</v-btn>
            </v-form>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'UploadView',
  data() {
    return {
      selectedFile: null,
      loading: false,
      uploadProgress: 0,
      allowedTypes: ['pdf', 'docx', 'pptx', 'txt', 'zip']
    }
  },
  methods: {
    onFileChange(file) {
      this.selectedFile = file
    },
    validateFileType(file) {
      if (!file) return true
      const extension = file.name.split('.').pop().toLowerCase()
      return this.allowedTypes.includes(extension) || `Invalid file type: .${extension}`
    },
    formatSize(bytes) {
      const kb = bytes / 1024
      return kb < 1024 ? `${kb.toFixed(2)} KB` : `${(kb / 1024).toFixed(2)} MB`
    },
    handleUpload() {
      if (this.selectedFile && this.validateFileType(this.selectedFile) === true) {
        this.loading = true
        this.uploadProgress = 0

        const interval = setInterval(() => {
          if (this.uploadProgress < 100) {
            this.uploadProgress += 10
          } else {
            clearInterval(interval)
            alert(`Upload complete: ${this.selectedFile.name}`)
            this.loading = false
            this.selectedFile = null
          }
        }, 200) // Simulate upload progress
      } else {
        alert('Please select a valid file type.')
      }
    }
  }
}
</script>

<style scoped>

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
</style>
